import { all, put, takeEvery, call } from 'redux-saga/effects';
import { PRINTERS_ACTIONS, PRINTERS_TYPES } from './actions';
import { getPrinters } from '../../services/printer';

export function* watchPrintersActions() {
  yield all([takeEvery(PRINTERS_TYPES.LOAD_PRINTERS, loadPrinters)]);
}

function* loadPrinters() {
  try {
    const response = yield call(getPrinters);
    const printers = response.printer;
    yield put(PRINTERS_ACTIONS.loadPrintersSuccess(printers));
  } catch (e) {
    yield put(PRINTERS_ACTIONS.loadPrintersSuccess(e));
  }
}
